// src/components/NotFound.js
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="content-wrapper">
        {/* Efecto de número flotante */}
        <div className="floating-number">404</div>
        
        {/* Contenido principal */}
        <div className="text-content">
          <h1 className="title">¡Ups! Página no encontrada</h1>
          <p className="description">
            La página que buscas podría haber sido eliminada, cambiado de nombre o<br/>
            está temporalmente inaccesible.
          </p>
          
          {/* Botón animado */}
          <Link 
            to="/" 
            className="home-button"
          >
            Volver al inicio
          </Link>
        </div>

        {/* Efecto visual adicional */}
        <div className="emoji">👻</div>
      </div>
    </div>
  );
};

export default NotFound;